import currency from "currency.js";
import { fetchActionsUtil, formatForQty } from "../../utils/helpers";
import {
  BookIcon,
  BucketIcon,
  ClockIcon,
  CustomCustomerInvoiceIcon,
  InvoiceDashboardIcon,
  InvoiceOverDue,
  InvoicePaidIcon,
  InvoiceUpcomingIcon,
  InvoiceUpnaidIcon,
  LineChartIcon,
  NewUserIcon,
  OverdueInvoiceStatsIcon,
  PaidInvoiceStatIcon,
  SideBarToggleIcon,
  UnpaidInvoiceStatsIcon,
  UpcomingInvoiceStatsIcon,
  UserIcon,
} from "../Icons";
import { Link, Outlet } from "react-router-dom";
import "../../assets/scss/customInvoiceWrapper.scss";
import InvoiceAnalysisChart from "./InvoiceAnalysisChart";
import InvoiceAnalysisPieChart from "./InvoiceAnalysisPieChart";
import { useEffect, useState } from "react";
import { Accordion, Button } from "react-bootstrap";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { useQueryParams } from "../../utils/hooks";

import queryString from "query-string";

const items = [
  { name: "Dashboard", icon: <InvoiceDashboardIcon />, link: "" },
  {
    name: "Purchase Order",
    icon: <InvoiceOverDue />,
    link: "/vendor-user/PO",
  },

  {
    name: "E-Procurement",
    icon: <InvoiceOverDue />,
    link: "/vendor-user/Request-For-Quote",
  },
  {
    name: "Quotes",
    icon: <InvoiceOverDue />,
    link: "/vendor-user/Quotes",
  },

  {
    name: "Ledger",
    icon: <InvoiceOverDue />,
    link: "/vendor/vendors-ledger",
  },

  {
    name: "Unpaid",
    icon: <InvoiceUpnaidIcon />,
    link: "/vendor-user/unpaid-invoices",
  },
  {
    name: "Upcoming",
    icon: <InvoiceUpcomingIcon />,
    link: "/vendor-user/upcoming-invoices",
  },
  {
    name: "Overdue",
    icon: <InvoiceOverDue />,
    link: "/vendor-user/overdue-invoices",
  },
  {
    name: "Paid",
    icon: <InvoicePaidIcon />,
    link: "/vendor-user/paid-invoices",
  },
];
export default function VendorsDashboardWrapperLayout({
  children,
  isStore = false,
}) {
  const [isOpen, setIsOpen] = useState(true);
  let {
    backendUrl,
    customerBackendUrl,
    //  token,
    user: authUser,
    customer,
    authVendor,
  } = useAuth();

  const initialFilterParams = {
    // Staff_ID: customer?.Staff_ID,
    Vendor_ID: authVendor?.Vendor_ID,
    customerId: authVendor?.Vendor_ID,
    customerName: authVendor?.CompanyName,
  };

  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });

  useEffect(() => {
    setQueryParams({
      ...queryParams,
      customerId: authVendor?.Vendor_ID,
      Vendor_ID: authVendor?.Vendor_ID,
      customerName: authVendor?.CompanyName,
    });
  }, [authUser?.Vendor_ID, authVendor?.CompanyName]);

  const { data, refetch, isFetching, isSuccess } = useQuery(
    ["FETCH_INVOICE_STATISTICS_DASHBOARD", queryParams],
    () =>
      fetchActionsUtil(
        `${
          isStore ? customerBackendUrl : backendUrl
        }/api/invoice/dashboard-layout-vendor-stats?&${queryString.stringify(
          queryParams
        )}`,
        "GET"
      ),
    {
      keepPreviousData: true,
    }
  );

  return (
    <>
      <div className="custom-invoice-wrapper " style={{ minHeight: "90vh" }}>
        <div className={"d-flex"}>
          {!isStore ? (
            <div
              className={isOpen ? "dashboard-menu" : " dashboard-menu-close"}
            >
              <div className="">
                <ul>
                  {items.map((item, index) => {
                    // if (
                    //   authUser?.planType?.toLowerCase() === "free" &&
                    //   ["quotation", "scheduled transactions"].includes(
                    //     item?.name?.toLowerCase()
                    //   )
                    // ) {
                    //   return null;
                    // }
                    return (
                      index <= 4 && (
                        <Link
                          to={`${item.link}?Vendor_ID=${
                            authVendor?.Vendor_ID
                          }&customerId=${authVendor?.Vendor_ID}&customerName=${
                            authVendor?.CompanyName
                          }`}
                          className="btn d-flex    align-items-center gap-1 custom-link"
                          title={!isOpen ? item?.name : ""}
                        >
                          <div className="icon">{item.icon}</div>
                          {isOpen && <span>{item.name}</span>}
                        </Link>
                      )
                    );
                  })}
                  {/* <button
                  className="  bg-primary"
                  onClick={() => setIsOpen((prev) => !prev)}
                >
                  <SideBarToggleIcon />
                </button> */}

                  <Accordion
                    defaultActiveKey="1"
                    className="custom-accordion border-0"
                    flush
                  >
                    <Accordion.Item eventKey="0" className=" border-0">
                      <Accordion.Header className="custom-header fw-normal">
                        <div className="custom-header-content">
                          <p
                            className=" align-items-center
              d-flex   gap-1"
                          >
                            <CustomCustomerInvoiceIcon /> <p>My Invoices</p>
                          </p>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        {items.map((item, index) => {
                          // if (
                          //   authUser?.planType?.toLowerCase() === "free" &&
                          //   ["quotation", "scheduled transactions"].includes(
                          //     item?.name?.toLowerCase()
                          //   )
                          // ) {
                          //   return null;
                          // }
                          return (
                            index > 4 && (
                              <Link
                                to={`${item.link}?Vendor_ID=${
                                  authVendor?.Vendor_ID
                                }&customerId=${
                                  authVendor?.Vendor_ID
                                }&customerName=${authVendor?.CompanyName}`}
                                className="btn d-flex    align-items-center gap-1 custom-link"
                                title={!isOpen ? item?.name : ""}
                              >
                                <div className="icon">{item.icon}</div>
                                {isOpen && <span>{item.name}</span>}
                              </Link>
                            )
                          );
                        })}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </ul>
              </div>
            </div>
          ) : null}

          <div className="custom-invoice-stats">
            <section className=" custom-stat-items">
              <section className={`custom-stats mb-3  `}>
                {/* <div className="custom-stat  border rounded-4">
                  <div className="icon icon-1">
                    <PaidInvoiceStatIcon />
                  </div>
                  <div className="custom-details">
                    <p>
                      {currency(Number(data?.data?.paid), {
                        symbol: "",
                        precision: 2,
                        format: formatForQty,
                      }).format()}
                    </p>
                    <span>Paid</span>
                  </div>
                </div>

                <div className="custom-stat  border rounded-4">
                  <div className="icon bg-light-blue">
                    <UpcomingInvoiceStatsIcon />
                  </div>
                  <div className="custom-details">
                    <p>
                      {currency(Number(data?.data?.upcoming), {
                        symbol: "",
                        precision: 2,
                        format: formatForQty,
                      }).format()}
                    </p>
                    <span>Upcoming</span>
                  </div>
                </div>

                <div className="custom-stat  border rounded-4">
                  <div className="icon ">
                    <OverdueInvoiceStatsIcon />
                  </div>
                  <div className="custom-details">
                    <p>
                      {currency(Number(data?.data?.overdue), {
                        symbol: "",
                        precision: 2,
                        format: formatForQty,
                      }).format()}
                    </p>
                    <span>Overdue</span>
                  </div>
                </div>

                <div className="custom-stat  border rounded-4">
                  <div className="icon  icon-2">
                    <UnpaidInvoiceStatsIcon />
                  </div>
                  <div className="custom-details">
                    <p>
                      {currency(Number(data?.data?.unpaid), {
                        symbol: "",
                        precision: 2,
                        format: formatForQty,
                      }).format()}
                    </p>
                    <span>Unpaid</span>
                  </div>
                </div> */}

                <Link
                  to={`/vendor-user/paid-invoices?Vendor_ID=${
                    authVendor?.Vendor_ID
                  }&customerId=${authVendor?.Vendor_ID}&customerName=${
                    authVendor?.CompanyName
                  }`}
                >
                  <div className="custom-stat  border rounded-4">
                    <div className="icon icon-1">
                      <PaidInvoiceStatIcon />
                    </div>

                    <div className="custom-details">
                      <p>
                        {currency(Number(data?.data?.paid), {
                          symbol: "",
                          precision: 2,
                          format: formatForQty,
                        }).format()}
                      </p>
                      <span>Paid</span>
                    </div>
                  </div>
                </Link>

                <Link
                  to={`/vendor-user/upcoming-invoices?Vendor_ID=${
                    authVendor?.Vendor_ID
                  }&customerId=${authVendor?.Vendor_ID}&customerName=${
                    authVendor?.CompanyName
                  }`}
                >
                  <div className="custom-stat  border rounded-4">
                    <div className="icon bg-light-blue">
                      <UpcomingInvoiceStatsIcon />
                    </div>
                    <div className="custom-details">
                      <p>
                        {currency(Number(data?.data?.upcoming), {
                          symbol: "",
                          precision: 2,
                          format: formatForQty,
                        }).format()}
                      </p>
                      <span>Upcoming</span>
                    </div>
                  </div>
                </Link>

                <Link
                  to={`/vendor-user/overdue-invoices?Vendor_ID=${
                    authVendor?.Vendor_ID
                  }&customerId=${authVendor?.Vendor_ID}&customerName=${
                    authVendor?.CompanyName
                  }`}
                >
                  <div className="custom-stat  border rounded-4">
                    <div className="icon ">
                      <OverdueInvoiceStatsIcon />
                    </div>
                    <div className="custom-details">
                      <p>
                        {currency(Number(data?.data?.overdue), {
                          symbol: "",
                          precision: 2,
                          format: formatForQty,
                        }).format()}
                      </p>
                      <span>Overdue</span>
                    </div>
                  </div>
                </Link>

                <Link
                  to={`/vendor-user/unpaid-invoices?Vendor_ID=${
                    authVendor?.Vendor_ID
                  }&customerId=${authVendor?.Vendor_ID}&customerName=${
                    authVendor?.CompanyName
                  }`}
                >
                  <div className="custom-stat  border rounded-4">
                    <div className="icon  icon-2">
                      <UnpaidInvoiceStatsIcon />
                    </div>
                    <div className="custom-details">
                      <p>
                        {currency(Number(data?.data?.unpaid), {
                          symbol: "",
                          precision: 2,
                          format: formatForQty,
                        }).format()}
                      </p>
                      <span>Unpaid</span>
                    </div>
                  </div>
                </Link>
              </section>

              {children}
            </section>
          </div>
        </div>

        {/* {Nav && <div className="nav-bar">{Nav}</div>} */}
        <Outlet />
      </div>
    </>
  );
}
